module.exports = __webpack_public_path__ + "static/img/zhongyongmajiang.0bfe4f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/zhongyongmajiang.jpg
// module id = 8R+o
// module chunks = 0